import { IoMdClose } from 'react-icons/io'
import { useIsMutating } from '@tanstack/react-query';
import { useDividas } from "../../../../../context/DividasContext";
import { useFila } from '../../../../../context/FilaContext';
import { Form } from './components/form'

interface FormCadastroProps {
  credor?: number;
  url?: string;
}

//https://mambaui.com/components/table
export const FormCadastro = ({ credor, url }: FormCadastroProps) => {
  const { devedorCadastro, devedor, clearDividas } = useDividas()
  const { devedorFilaSelected, endQueue, clearSelectedFila } = useFila()

  async function handleEncerrarAtendimento() {
    await endQueue(devedorFilaSelected.id_queue)
    clearSelectedFila()
    clearDividas()
  }

  const isMutation = useIsMutating({ mutationKey: ['form'] })

  function mostrarForm() {
    if (!devedor?.cpf_cnpj && !devedorCadastro?.dadoscadastrais && devedor !== null) {
      return (
        <div className="w-full text-center text-primary font-bold">
          <h3>Clique duas vezes em um dos devedores ao lado para iniciar o atendimento!</h3>
        </div>
      )
    } else if (devedorCadastro?.dadoscadastrais && devedor !== null) {
      return <Form credor={credor} url={url} />
    } else {
      return (
        <div className="w-full text-center flex items-center justify-center flex-col gap-8 text-primary font-bold">
          {isMutation === 0 && <>
            <h3>Esse cliente nao está cadastrado em nosso banco de dados!</h3>
            <button type='button' className="bg-error flex p-3 gap-2 items-center text-sm text-white rounded-md" onClick={handleEncerrarAtendimento}>
              <IoMdClose size={22} className='fill-white' color='#fff' />
              <p>Encerrar atendimento</p>
            </button>
          </>}

        </div>
      )
    }
  }

  return (
    <>
      <div className=" max-h-full px-1">
        {mostrarForm()}
      </div>
    </>
  );
};
